import React from 'react';
import TableHeader from './TableHeader';
import TableBody from './TableBody';

const Table = ({
  columns,
  sortColumn,
  onSort,
  data,
  checkBox,
  setSelectedRows,
  selectedRows,
  tableRef,
  loading,
  handleSelectAll,
  handleRowClick,
  responsive = true,
  contentLoading = false,
  formListings= false,
   type = '',
}) => {
  const teamTable =
    columns[0]?.label === 'Employees' ||
    columns[1]?.label === 'Stages' ||
    columns[1]?.label === 'pipeline-templates';
  return (
    <div className={`rounded border ${!teamTable && responsive && 'table-responsive'}`}>
      <table className="table mb-0">
        <TableHeader
          columns={columns}
          data={data}
          handleSelectAll={handleSelectAll}
          checkBox={checkBox}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          sortColumn={sortColumn}
          tableRef={tableRef}
          onSort={onSort && onSort}
          formListings={formListings}
          type={type}
        />
        <TableBody
          columns={columns}
          checkBox={checkBox}
          handleRowClick={handleRowClick}
          data={data}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          tableRef={tableRef} // Use tableRef directly
          loading={loading}
          contentLoading={contentLoading}
          formListings={formListings}
        />
      </table>
    </div>
  );
};

export default Table;
